import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiLogIn } from 'react-icons/fi';
import AdminLayout from '../AdminLayout/AdminLayout';
import { useMessages } from '../../../i18n/I18n';
import './Admin.css';

const TOOLS = [
  {
    path: '/admin/create-festival',
    key: 'createFestival',
  },
  {
    path: '/admin/create-user',
    key: 'createUser',
  },
  {
    path: '/admin/festivals-list',
    key: 'festivalsList',
  },
  {
    path: '/admin/migrations',
    key: 'migrations',
  },
  {
    path: '/admin/update-firebase-secret',
    key: 'firebaseSecret',
  },
] as const;

const Admin: React.FC = () => {
  const t = useMessages('admin');
  return (
    <AdminLayout
      className="admin-home"
      title={t.adminTools}
      description={t.homeDescription}
      headerAction={
        <Link to="/" className="btn btn-ghost">
          <FiLogIn aria-hidden="true" />
          {t.backToSignIn}
        </Link>
      }
    >
      <nav className="admin-tools" aria-label={t.adminTools}>
        {TOOLS.map(tool => (
          <Link key={tool.path} to={tool.path} className="admin-tool">
            <span className="admin-tool-text">
              <span className="admin-tool-title">{t.tools[tool.key].title}</span>
              <span className="admin-tool-description">{t.tools[tool.key].description}</span>
            </span>
            <FiChevronRight className="admin-tool-chevron" aria-hidden="true" />
          </Link>
        ))}
      </nav>
    </AdminLayout>
  );
};

export default Admin;
